<template>
  <div class="p-6 bg-white/60 rounded-xl min-h-screen">
    <div>
      <div class="bg-white rounded-xl p-1 mb-2">
        <div class="flex justify-between items-center">
          <h3 class="text-xl font-bold text-purple-600 p-3">
             <span
                 class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500">
                 پکینگ ایرانی
             </span>
          </h3>
          <div class="text-sm text-gray-500">
            از فایل: <span class="font-bold text-purple-600">{{ packing.xlsx_file_name }}</span>
          </div>
          <div class="text-sm text-gray-500 ml-2">
            تاریخ : <span class="font-bold text-purple-600">{{ packing.registration_date }}</span>
          </div>
        </div>

        <div>
          <div class="data-card bg-white m-1">
            <div class="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
              <div
                  v-for="info in [
                      { icon: 'fas fa-heading', color: 'text-blue-600 bg-blue-100', label: 'عنوان', value: packing.title || '---' },
                      { icon: 'fas fa-file-invoice', color: 'text-pink-600 bg-pink-100', label: 'فاکتور', value: packing.factor_number || '---' },
                      { icon: 'fas fa-shipping-fast', color: 'text-green-600 bg-green-100', label: 'هزینه ارسال', value: packing.cargo_cost_per_shipping },
                      { icon: 'fas fa-truck-loading', color: 'text-amber-600 bg-amber-100', label: 'تامین‌کننده', value: packing.supplier_name },
                      { icon: 'fas fa-cube', color: 'text-purple-600 bg-purple-100', label: 'تعداد آیتم', value: items.length },
                      { icon: 'fas fa-coins', color: 'text-blue-600 bg-blue-100', label: 'مبلغ فاکتور', value: (packing.base_amount | toMoney(0)) },
                      { icon: 'fas fa-comment-dots', color: 'text-indigo-600 bg-indigo-100', label: 'توضیحات', value: body.explanation || '---' },
                    ]"
                  :key="info.label"
                  class="flex items-center space-x-1 bg-gray-50 px-2 py-1 rounded-lg text-gray-700"
              >
                <i :class="[info.icon, info.color, 'p-1 rounded-full text-[10px]']"></i>
                <span class="font-semibold">{{ info.label }}:</span>
                <span class="truncate">{{ info.value }}</span>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-md shadow-sm border border-gray-100 overflow-hidden">
      <div class="overflow-y-auto " style="max-height: calc(100vh - 30vh);">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-900 border border-red-50 sticky top-0 z-10">
          <tr>
            <th class="text-[8px]  text-white text-center p-1 border  w-1">ردیف</th>
            <th class="text-[8px]  text-white text-center p-1 border w-min">تصویر</th>
            <th class="text-[8px]  text-white text-center p-1 border w-min">
              <input
                  v-model="searchGroup"
                  class="w-full h-full text-center text-blue-200 leading-none rounded-sm bg-gray-700"
              />
            </th>
            <th class="text-[8px]  text-white text-center p-1 border w-min">
              <input
                  v-model="searchSKU"
                  class="w-full h-full text-center text-blue-200 leading-none rounded-sm bg-gray-700"
              />
            </th>
            <th class="text-[8px]  text-white text-center p-1 border w-min">نام محصول</th>
            <th class="text-[8px]  text-white text-center p-1 border">تعداد کل</th>
            <th class="text-[8px]  text-white text-center p-1 border">قیمت مصرف کننده</th>
            <th class="text-[8px]  text-white text-center p-1 border">قیمت پایه</th>
            <th class="text-[8px]  text-white text-center p-1 border"> حاشیه سود</th>
            <th class="text-[8px]  text-white text-center p-1 border">مبلغ سود</th>
            <th class="text-[8px]  text-white text-center p-1 border">در صورت فروش</th>
            <th class="text-[8px]  text-white text-center p-1 border">جمع کل قیمت پایه</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in filteredItems" :key="item.id"
              class="hover:bg-gray-50 transition">
            <td class="text-center  text-[10px] border">{{ index + 1 }}</td>
            <td class="text-center  text-[10px] border">
              <div v-if="item.image" class="w-12 h-12 mx-auto">
                <img :src="item.image" :alt="item.name" class="w-full h-full object-cover rounded">
              </div>
              <div v-else class="text-gray-400">
                <i class="fas fa-image text-xl"></i>
              </div>
            </td>
            <td class="text-center p-1 text-[10px] border">{{ item.group_id || '---' }}</td>
            <td class="text-center p-1 text-[10px] border">{{ item.sku || '---' }}</td>
            <td class="text-center p-1 border text-[8px] w-min">
              {{ item && item.name !== undefined ? truncateText(item.name) : '' }}
            </td>
            <td class="text-center p-1 text-[10px] border">{{ item.total }}</td>
            <td class="text-center p-1 text-[10px] border">{{ item.regular_price | toMoney(0)}}</td>
            <td class="text-center p-1 text-[10px] border">{{ item.price | toMoney(0)}}</td>

            <td class="text-center  border text-[10px]">{{ item.profit_margin }}
              <span class="text-[8px]">
              {{item.profit_type_name.slice(0, -1)}}
            </span>
            </td>
            <td class="text-center  border text-[10px]">{{ item.profit | toMoney(0) }}</td>

            <td class="text-center  border text-[10px]">{{ item.final_amount | toMoney(0)}}
              <span class="text-[8px]">
              تومان
            </span>
            </td>
            <td class="text-center  border text-[10px]">{{ item.total_final | toMoney(0)}}
              <span class="text-[8px]">
              تومان
            </span>
            </td>

          </tr>
          <tr v-if="loading">
            <td colspan="6" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="items.length === 0">
            <td colspan="6" class="p-4 text-center text-gray-500">
              یافت نشد
            </td>
          </tr>

          <tr v-for="(packageItem, index) in items" :key="packageItem.id"
              class="hover:bg-gray-50 transition">
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">

        <div
            class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"/>
          </svg>
        </div>

        <div class="mr-3 text-sm font-normal pr-2">تایید شد</div>

        <button @click="showNotification = false"
                class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>

  </div>
</template>

<script>
import PackingStoreHandle from "@/modules/store_handle/PackingStoreHandle";
import StoreSelect from "@/components/selects/StoreSelect";

export default {
  name: 'DomesticPackingDetail',
  components: {StoreSelect, PackingStoreHandle},
  props: {
    id: {},
  },
  data() {
    return {
      searchGroup: '',
      searchSKU: '',
      showNotification: false,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: true,
      items: [],
      suppliers: [],
      packing: {},
      totalPackages: 0,
      currentPage: 1,
      activePricing: [],
      itemsPerPage: 20,
      body: {
        title: '',
        factor_number: '',
        supplier: '',
        explanation: '',
        cargo_cost_per_shipping: 0,
      },
      categories: [],
      brands: [],
      productSelected: null,
      showProductStoreHandle: false
    }
  },
  computed: {
    filteredItems() {
      if (!this.searchGroup && !this.searchSKU) return this.items
      if (this.searchSKU) {
        return this.items.filter(item =>
            item.sku && item.sku.toString().includes(this.searchSKU)
        )
      }
      if (this.searchGroup) {
        return this.items.filter(item =>
            item.group_id && item.group_id.toString().includes(this.searchGroup)
        )
      }
    },

    totalPrice() {
      return this.items.reduce((sum, item) => sum + (item.price || 0), 0);
    },
    totalQuantityPerBox() {
      return this.items.reduce((sum, item) => sum + (item.quantity_per_box || 0), 0);
    },
    totalBoxQuantity() {
      return this.items.reduce((sum, item) => sum + (item.box_quantity || 0), 0);
    },
    totalQuantity() {
      return this.items.reduce((sum, item) => sum + (item.total_quantity || 0), 0);
    },
    totalAmount() {
      return this.items.reduce((sum, item) => sum + ((item.price || 0) * (item.total || 1)), 0);
    },
    totalFinalAmount() {
      return this.items.reduce((sum, item) => sum + (item.total_final || 0), 0);
    },
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage)
      const range = 1
      const pages = []

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },
  methods: {
    calculateRowIndex(index) {
      return (this.currentPage - 1) * this.itemsPerPage + index + 1;
    },
    viewDetails(packageItem) {
      alert(`جزئیات بسته: ${packageItem.name}\nشناسه: ${packageItem.id}\nتعداد آیتم‌ها: ${packageItem.items_count}`);
    },
    downloadFile(packageItem) {
      if (!packageItem.uploaded_file) {
        this.showNotificationMessage('فایل آپلود شده موجود نیست', 'error');
        return;
      }

      this.showNotificationMessage('در حال دانلود فایل...', 'success');
      // شبیه‌سازی دانلود فایل
      setTimeout(() => {
        this.showNotificationMessage('فایل با موفقیت دانلود شد', 'success');
      }, 1500);
    },
    exportToExcel() {
      this.showNotificationMessage('در حال آماده‌سازی خروجی Excel...', 'success');
      // شبیه‌سازی تولید فایل Excel
      setTimeout(() => {
        this.showNotificationMessage('خروجی Excel با موفقیت تولید شد', 'success');
      }, 2000);
    },

    isActive(product) {
      return this.activePricing.some(p => p === product);
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    handleDone(product) {
      this.request({
        url: this.endpoint(`entrance/createChinaEntrancePackageFromExtracted/${this.id}`),
        method: 'post',
        data: this.body,
        success: (data) => {
          this.showNotificationMessage()
          this.fetchPacking()
        },
      })
    },
    fetchPacking() {
      this.loading = true

      this.request({
        url: this.endpoint(`entrance/domesticEntrancePackage/${this.id}`),
        method: 'get',
        success: (data) => {
          this.packing = data
          this.items = data.items
          this.totalPackages = 0
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchPacking()
    },

    resetFilters() {
      this.filters = {
        id_in: '',
        name__icontains: '',
      }
      this.applyFilters()
    },

    refreshProducts() {
      this.fetchPacking()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchPacking()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++
        this.fetchPacking()
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchPacking()
      }
    },
    productStoreHandle(product) {
      this.selectedProduct = product
      this.showProductStoreHandle = true

    },
    active(product) {
      const index = this.activePricing.indexOf(product);
      if (index > -1) {
        this.activePricing.splice(index, 1);
      } else {
        this.activePricing.push(product);
      }
    },
    calculate_discount(price, discount) {
      return price - (price / 100 * discount)
    },
    closeProductStoreHandle() {
      this.selectedProduct = null
      this.showProductStoreHandle = false
    },

    fetchSuppliers() {
      this.request({
        url: this.endpoint('main/supplier'),
        method: 'get',
        success: (data) => {
          this.suppliers = data
        }
      })
    },
    truncateText(text) {
      if (!text) return ''
      return text.length > 50 ? text.slice(0, 35) + '...' : text
    },

  },
  mounted() {
    this.fetchSuppliers()
    this.fetchPacking()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.bg-secondary {
  background-color: #424242;
}
.data-card {
  transition: all 0.3s ease;
  box-shadow: 0 10px 25px -5px rgba(14, 165, 233, 0.1);
}
.data-card:hover {
  box-shadow: 0 20px 35px -5px rgba(14, 165, 233, 0.15);
  transform: translateY(-2px);
}
.data-item {
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}
.data-item:hover {
  border-left-color: #ff8700;
}
.animate-pulse-slow {
  animation: pulse 3s infinite;
}
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.9; }
}

</style>